import styled from 'styled-components';

export const StyledExitIntentPopup = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items:center;
    background-color: rgba(151,151,151,0.8);
    z-index: 3111222444;
    &[data-visible="false"]{
        display:none;
    }
    &[data-visible="false"]{
        display:none;
    }
`;

export const ContentContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 540px;
    height: 542px;
    background-color: #ffffff; 
`;

export const ClosePopupButton = styled.div`
    position: absolute;
    right: 22px;
    top: 19px;
    width: 14px;
    height: 14px;
    background-image: url("../images/popup_x_button.png");
    background-size: cover;
    background-repeat: no-repeat;
    cursor: pointer;
    z-index: 4;
`;

export const FormCompletionCheckMark = styled.div`
    background-image: url("../images/SuccessState-Checkmark.svg");
    background-repeat: no-repeat;
    background-size: contain;
    height: 80px;
    width: 70px;
`;

export const ContentHeader = styled.div`
    position: relative;
    width: 100%;
    height: 230px;
    background-repeat: no-repeat;
    background-size: cover;
    background-image: url("../images/PopUp_Art_2A_copy_14.png");
`;

export const ContentBody = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 200px;
    width: 100%;
    justify-content: center;
    align-items: center;
    padding: 26px 31px 31px 31px;
    .popup-title,
    .popup-title2{
        font-size: 24px;
        font-weight: bold;
        width: 100%;
        line-height: 28px;
        margin-bottom: 20px;
    }
    .popup-subtitle,
    .popup-subtitle2{
        font-size: 14px;
        line-height: 19px
        font-weight: 400;
        text-align: center;
        margin-bottom: 20px;
    }
    .no-thanks{
        margin-top: 12px;
        font-size: 16px;
        line-height 21px;
        font-weight: 400;
        color: var(--color-primary);
        cursor: pointer;
        transition: all .1s;

        &:hover{
            text-decoration: underline;
            color: var(--color-primary-dark) !important;
        }
    }
    .mktoForm{
        flex-direction: column;
    }
    .mktoForm input{
        border: 1px solid #aeaeae !important;
        font-size: 16px !important;
        font-family: var(--font-body) !important;
        padding-top: 11px !important;
        padding-bottom: 11px !important;
        width: 442px !important;
        max-width: 100% !important;
        text-align: center;
        color: #c0c0c0;
    }
    .mktoSimple .mktoButton{
        font-family: var(--font-body) !important;
        margin-top: 16px;
        transition: all .1s;
        background-color: var(--color-primary);

        &:hover{
            color: white;
            background-color: var(--color-primary-dark) !important;
        }
    }
`;

export const PopupTitle = styled.div``;

export const PopupSubtitle = styled.div``;

export const PopupNoThanks = styled.div``;